import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useRouter } from '@shared/router';
import { ExchangeRefundModalData } from '@entities/order';
import { getErrorMessage } from '@shared/lib/error';
import { closeRefundServicesModal, setRefundServicesModal } from '../model';

export const useShowRefundServicesErrorModal = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation('RefundServices');
	const router = useRouter();

	return (error: unknown) => {
		if (!error) {
			return;
		}

		const message = getErrorMessage(error, 'ErrorModal.DefaultTitle');

		let title = t('ErrorModal.DefaultTitle');
		const description = t('ErrorModal.DefaultDescription');
		let close = () => dispatch(closeRefundServicesModal());

		if (message.includes('This operation is not available')) {
			title = t('This operation is not available');
			close = null;
		} else if (message.includes('There are no services available for refund')) {
			title = t('There are no services available for refund');
			close = null;
		}

		const modalData: ExchangeRefundModalData = {
			status: 'error',
			title,
			description,
			close,
			success: {
				text: t('ErrorModal.BackToOrder'),
				onClick: () => {
					dispatch(closeRefundServicesModal());
					router.navigate('/order');
				}
			}
		};

		dispatch(setRefundServicesModal(modalData));
	};
};
